import { store } from "@risingstack/react-easy-state";

const YoutubeVideoStore = store({
    players:[],
    isSliding:false,
    toggle: ()=>{YoutubeVideoStore.isSliding = !YoutubeVideoStore.isSliding},
    setPlayers:(players)=>{YoutubeVideoStore.players = players},
});

export default YoutubeVideoStore;